import { ApiInstance } from './base'

const IntegrationService = {
    spApiAuth(params) {
        return ApiInstance.post('/integration/sp-api', params)
    },
}

export default IntegrationService
